import AxiosInstance from 'utils/AxiosInstance'
import axios from 'axios'
import {
  BASE_URL_API as baseURLNode,
  ACCESS_TOKEN as accessToken,
} from 'utils/helpers'
import * as types from './constants'
import history from 'utils/history'
import { isValidURL } from 'utils/helpers'
import { isTextEmpty } from 'utils/helpers'
import { clientBaseUrl } from 'utils/AxiosInstance'

// Saved items are applied to the lists in place (see reducer) instead of refetching,
// so nothing flashes a loader after an add / edit.
const upsertLibraryItems = (items) => ({
  type: types.UPSERT_LIBRARY_ITEMS,
  items,
})

// Clears the upload progress/status so the submit button is back to normal.
export const resetUploadState = () => (dispatch) => {
  dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
  dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent: 0 })
}

// Points the "Move to" selection back at the folder currently being viewed.
export const syncSelectedFolder = () => (dispatch, getState) => {
  dispatch({
    type: types.SELECT_FOLDER,
    id: getState().library.parentId ?? null,
  })
}

// Folder an add-content request should land in: whatever is selected in the modal,
// falling back to the folder being viewed. null means the library root.
const resolveTargetFolder = (selectedFolder, parentId) => {
  if (selectedFolder === 'lib') return null
  if (selectedFolder === '' || selectedFolder === undefined) {
    return parentId || null
  }
  return selectedFolder
}

export const setOverlayShowing = (overlayIsShowing) => ({
  type: types.SET_OVERLAY_SHOWING,
  overlayIsShowing,
})
export const setFileOverlayShowing = (fileOverlayIsShowing) => ({
  type: types.SET_FILE_OVERLAY_SHOWING,
  fileOverlayIsShowing,
})

export const setSearchValue = (searchValue) => ({
  type: types.SET_SEARCH_VALUE,
  searchValue,
})
export const setAssignSearchValue = (assignSearchValue) => ({
  type: types.SET_ASSIGN_SEARCH_VALUE,
  assignSearchValue,
})
export const setFilesParents = (filesParents) => ({
  type: types.SET_FILES_PARENTS,
  filesParents,
})
export const setPublic = (value) => ({ type: types.SET_FILE_SCOPE, value })
export const resetSelectedItems = () => ({ type: types.RESET_SELECTED_ITEMS })

export const setShowSelectedOrgGroups = () => ({
  type: types.SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: true,
})
export const setHideSelectedOrgGroups = () => ({
  type: types.SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: false,
})

export const setShowSelectedUsers = () => ({
  type: types.SET_SHOW_SELECTED_USERS,
  showSelectedUsers: true,
})
export const setHideSelectedUsers = () => ({
  type: types.SET_SHOW_SELECTED_USERS,
  showSelectedUsers: false,
})

export const setShowSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: true,
})
export const setHideSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: false,
})

export const setShowSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: true,
})
export const setHideSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: false,
})

export const setShowSelectedLocationGroups = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: true,
})
export const setHideSelectedLocationGroups = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: false,
})

export const setShowSelectedRoleGroups = () => ({
  type: types.SET_SHOW_SELECTED_ROLE_GROUPS,
  showSelectedRoleGroups: true,
})
export const setHideSelectedRoleGroups = () => ({
  type: types.SET_SHOW_SELECTED_ROLE_GROUPS,
  showSelectedRoleGroups: false,
})

export const setShowSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: true,
})
export const setHideSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: false,
})

export const setCurrentTab = (
  currentTab,
  currentSelectedItems,
  currentItems,
  currentToggleFunction,
  currentShowSelectedItems,
  currentShowSelectedItemsFunction,
  currentHideSelectedItemsFunction,
) => {
  return (dispatch) => {
    dispatch({ type: types.SET_CURRENT_TAB, currentTab })
    dispatch({ type: types.SET_CURRENT_SELECTED_ITEMS, currentSelectedItems })
    dispatch({ type: types.SET_CURRENT_ITEMS, currentItems })
    dispatch({
      type: types.SET_CURRENT_TOGGLE_ITEM_FUNCTION,
      currentToggleFunction,
    })
    dispatch({
      type: types.SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
      currentHideSelectedItemsFunction,
    })
    dispatch({
      type: types.SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
      currentShowSelectedItemsFunction,
    })
    dispatch({
      type: types.SET_CURRENT_SHOW_SELECTED_ITEMS,
      currentShowSelectedItems,
    })
  }
}

// export const files = (id) => {
// 	return (dispatch) => {
// 		dispatch({ type: types.SET_PARENT_ID, parentId: id })

// 		dispatch({ type: types.SET_LIBRARY_ISLOADING, isLoading: true })
// 		id
// 			? dispatch(fetchParent(id))
// 			: dispatch({ type: types.SET_PARENT, data: null })
// 		AxiosInstance.get(`/library${id ? '/' + id : ''}`).then((data) => {
// 			dispatch({ type: types.LIBRARY, data })
// 			dispatch(fetchParents(id))
// 			dispatch({ type: types.SET_LIBRARY_ISLOADING, isLoading: false })
// 		})
// 	}
// }

export const fetchFiles = (id) => {
  return async (dispatch) => {
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: null })
    dispatch({ type: types.SET_PARENT_ID, parentId: id })

    dispatch({ type: types.SET_LIBRARY_ISLOADING, isLoading: true })
    id
      ? dispatch(fetchParent(id))
      : dispatch({ type: types.SET_PARENT, data: null })

    const allFoldersAndFiles = await AxiosInstance.get('/library/all')
    dispatch({ type: types.ALL_LIBRARY, payload: allFoldersAndFiles })

    return AxiosInstance.get(`/library${id ? '/' + id : ''}`).then((data) => {
      dispatch({ type: types.LIBRARY, data })
      dispatch(fetchParents(id))
      dispatch({ type: types.SET_LIBRARY_ISLOADING, isLoading: false })
      return Promise.resolve(data)
    })
  }
}

export const fetchParent = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/library/parent/${id}/`).then((data) => {
      dispatch({ type: types.SET_PARENT, data })
    })
  }
}

export const fetchFileAssignedGroups = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/library/${id}/groups-assigned`).then((data) => {
      if (data && data.length) {
        const orgGroups = data.map((item) => item.group_id)
        dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups })
      } else {
        dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups: [] })
      }
    })
  }
}

export const fetchParents = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/library/parents/${id}`).then((data) => {
      if (data.length) {
        dispatch({
          type: types.SET_FILES_PARENTS,
          filesParents: data.reverse(),
        })
      } else {
        dispatch({ type: types.SET_FILES_PARENTS, filesParents: data })
      }
    })
  }
}

export const onChange = (event) => {
  return (dispatch) => {
    const name = event.target.name
    const value = event.target.value

    dispatch({ type: types.ON_CHANGE, name, value })
  }
}

export const deleteFile = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null
    //eslint-disable-next-line
    if (confirm(language.alerts ? language.alerts.delete_file_confirm : null)) {
      // Removes the item (and anything inside it) from the visible and search lists.
      dispatch({ type: types.REMOVE_LIBRARY_ITEM, id })

      AxiosInstance.delete(`/library/${id}`).then(() =>
        dispatch(fetchAllFolders()),
      )
    }
  }
}

export const update = (event, old_parent, language = null) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const {
      parentId,
      fileUploadStatus,
      selectedOrgGroups,
      selectedUsers,
      selectedLocationGroups,
      selectedRoleGroups,
      selectedStores,
      selectedRoles,
      scope,
      selectedFolder,
      parent,
      allFolders,
    } = getState().library

    if (fileUploadStatus === 'started') {
      return
    }

    let rootParent =
      selectedFolder === null && parent?.id != null
        ? parent.id
        : selectedFolder != null && selectedFolder != 'lib'
          ? selectedFolder
          : null

    // selectedFolder === null ? null : parent.id ? parent.id : null

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })

    const nodes = event.target.elements
    const nameInput = [].filter.call(nodes, (item) => item.type === 'text')[0]
    const pathInput = [].filter.call(nodes, (item) => item.type === 'text')[1]

    // Look the checkboxes up by name: the private-assign tabs render checkboxes
    // too, so "the first checkbox" is not reliably the one we want.
    const newTabCheckbox = nodes['new_tab']

    const fileInput = [].filter.call(
      nodes,
      (item) => item.type === 'file' && item.name !== 'thumbnail',
    )[0]
    const thumbInput = nodes['thumbnail']
    const hiddenInput = [].filter.call(
      nodes,
      (item) => item.type === 'hidden',
    )[0]

    const showPrintDownloadCheckbox = nodes['showPrintDownload']

    const type = [].filter.call(nodes, (item) => item.type === 'hidden')[1]
      .value

    const id = hiddenInput.value
    const name = nameInput.value
    const path = pathInput?.value
    const newTab = newTabCheckbox?.checked
    const file = fileInput?.files[0]
    const thumb = thumbInput?.files[0]

    // Extract note_text for notes
    const noteTextInput = [].filter.call(
      nodes,
      (item) => item.name === 'note_text',
    )[0]
    const noteText = noteTextInput?.value

    const showPrintDownload =
      showPrintDownloadCheckbox && showPrintDownloadCheckbox.checked

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    const data = new FormData()

    if (!language || language?.length === 2) {
    } else if (language?.length === 1) {
      if (language?.at(0)?.option) {
        data.append('language', language[0].option.value)
      } else {
        data.append('language', language[0].value)
      }
    }

    if (showPrintDownloadCheckbox) {
      data.append('show_print_download', showPrintDownload)
    }

    if (path) {
      if (!isValidURL(path)) {
        dispatch(resetUploadState())
        alert('Please enter a valid URL')
        return
      }
      data.append('path', path)
    }

    if (newTabCheckbox) {
      data.append('new_tab', newTab)
    } else {
      data.append('new_tab', true)
    }

    if (scope == 'private' && type !== 'file') {
      const folder = allFolders.find((item) => item.id == id)

      const ids = []

      const iterate = (obj, ids) => {
        // console.log(obj, 'flatenFolder')

        Object.keys(obj).forEach((key) => {
          console.log(key, 'KEYYYYYY')
          if (key == 'id') {
            // ids = [...ids, obj[key]]

            ids.push(obj[key])

            console.log('KEYYYYYYVALUE', obj[key])
          }

          if (typeof obj[key] === 'object' && obj[key] !== null) {
            iterate(obj[key], ids)
          }
        })

        return ids
      }

      const flatenFolder = iterate(folder, ids)

      flatenFolder.map((item, index) => {
        data.append('childrens[' + index + ']', item)
      })
    }
    data.append('name', name)
    if (thumb) {
      data.append('thumbnail', thumb)
    }
    if (file) {
      data.append('file', file)
    }

    // Append note_text for notes
    if (noteText) {
      data.append('note_text', noteText)
      data.append('is_note', '1')
    }

    const selectedGroups = [
      ...selectedOrgGroups,
      ...selectedLocationGroups,
      ...selectedRoleGroups,
    ]

    selectedGroups.map((item, index) => {
      data.append('groups[' + index + ']', item)
    })

    selectedUsers.map((item, index) => {
      data.append('users[' + index + ']', item)
    })

    selectedRoles.map((item, index) => {
      data.append('roles[' + index + ']', item)
    })

    selectedStores.map((item, index) => {
      data.append('stores[' + index + ']', item)
    })

    data.append('type', type)

    data.append('scope', scope)

    // if (parent) {
    // 	data.append('parent_id', rootParent)
    // }

    data.append('selectedFolder', rootParent)

    axios
      .patch(`${clientBaseUrl()}/library/${id}?token=${accessToken()}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )

          dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent })
        },
      })
      .then(({ data: saved }) => {
        // The API answers failures with a 200 and just a message.
        if (!saved || !saved.id) {
          throw new Error((saved && saved.message) || 'Something went wrong')
        }

        // The API leaves `language` out of the response when both languages are
        // selected (it saves NULL), so default it to null before merging.
        dispatch(upsertLibraryItems([{ language: null, ...saved, type }]))

        // Folder names / locations feed the "Move to" dropdown.
        if (type === 'folder') {
          dispatch(fetchAllFolders())
        }

        history.replace(parentId ? '/library/folder/' + parentId : '/library')
        dispatch(resetUploadState())
        dispatch(resetSelectedItems())
        dispatch(
          setCurrentTab(
            'category',
            'selectedOrgGroups',
            'groupOrgs',
            'toggleOrgGroups',
          ),
        )
      })
      .catch((error) => {
        dispatch(resetUploadState())
        alert(error.message || 'Something went wrong')
      })
  }
}

// Replace the existing uploadMultiple function with this fixed version
export const uploadMultiple = (
  filesData,
  commonSettings,
  fileLanguages = null,
) => {
  return async (dispatch, getState) => {
    const {
      fileUploadStatus,
      parentId,
      selectedOrgGroups,
      selectedUsers,
      selectedLocationGroups,
      selectedRoleGroups,
      selectedStores,
      selectedRoles,
      scope,
    } = getState().library

    if (fileUploadStatus === 'started') {
      return
    }

    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null

    // Validate all files before starting any uploads
    for (const fileData of filesData) {
      if (!fileData.file && !fileData.path) {
        alert(
          language.alerts
            ? language.alerts.select_file
            : `Please select a file for ${fileData.name}`,
        )
        return
      }
      if (isTextEmpty(fileData.name)) {
        alert(
          `Title cannot be empty for file: ${fileData.file?.name || 'Unknown'}`,
        )
        return
      }
    }

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    // Fix target folder handling - null for root folder, not 0
    let rootParent = commonSettings.targetFolder
    if (rootParent === 'lib' || rootParent === 0) {
      rootParent = null // Root folder should be null
    }

    try {
      const data = new FormData()

      // FIXED: Add files and thumbnails with proper indexing
      // Instead of separate loops, we need to maintain order for multer.fields()
      filesData.forEach((fileData, index) => {
        if (fileData.file) {
          data.append('files', fileData.file)
        }

        // Always append thumbnail (even if empty) to maintain index alignment
        if (fileData.thumbnail) {
          data.append('thumbnails', fileData.thumbnail)
        } else {
          // Create empty blob placeholder to maintain index
          const emptyBlob = new Blob([''], { type: 'application/octet-stream' })
          data.append('thumbnails', emptyBlob, 'empty_thumbnail.tmp')
        }
      })

      // Add files metadata as JSON - include thumbnail info for backend processing
      data.append(
        'filesData',
        JSON.stringify(
          filesData.map((fileData, index) => ({
            name: fileData.name,
            path: fileData.path || '',
            newTab: fileData.newTab !== false,
            hasThumbnail: !!fileData.thumbnail, // Add this flag
            index: index, // Add explicit index
          })),
        ),
      )

      // Add common settings
      data.append(
        'commonSettings',
        JSON.stringify({
          targetFolder: rootParent, // This will be null for root folder
        }),
      )

      // Fix language handling - send single value or nothing
      if (fileLanguages && fileLanguages.length === 1) {
        // Single language selected - send the value (1 or 3)
        const languageValue = fileLanguages[0].option
          ? fileLanguages[0].option.value
          : fileLanguages[0].value
        data.append('language', languageValue)
      }
      // If both languages or no languages, don't append anything (will be null in backend)

      // Add other form data from state
      data.append('scope', scope)
      data.append('new_tab', 'true')
      data.append('show_print_download', 'false')
      data.append('selectedFolder', rootParent || 'lib')
      if (rootParent) {
        data.append('parent_id', rootParent)
      }

      // Add assignment data if private
      if (scope === 'private') {
        const selectedGroups = [
          ...selectedOrgGroups,
          ...selectedLocationGroups,
          ...selectedRoleGroups,
        ]

        if (selectedGroups.length > 0) {
          selectedGroups.forEach((item, index) => {
            data.append('groups[' + index + ']', item)
          })
        }

        if (selectedUsers.length > 0) {
          selectedUsers.forEach((item, index) => {
            data.append('users[' + index + ']', item)
          })
        }

        if (selectedRoles.length > 0) {
          selectedRoles.forEach((item, index) => {
            data.append('roles[' + index + ']', item)
          })
        }

        if (selectedStores.length > 0) {
          selectedStores.forEach((item, index) => {
            data.append('stores[' + index + ']', item)
          })
        }
      }

      // Upload all files in a single request
      const response = await axios.post(
        `${clientBaseUrl()}/library/multiple?token=${accessToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            )
            dispatch({
              type: types.LIBRARY_UPLOAD_PERCENT,
              percent: percent,
            })
          },
        },
      )

      // Handle response
      if (response.data.success) {
        // Show the new items right away instead of refetching the whole library.
        // (Strips the client-only helper fields the API echoes back.)
        dispatch(
          upsertLibraryItems(
            (response.data.data || []).map(
              ({ originalName, fileIndex, ...item }) => item,
            ),
          ),
        )

        dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'uploaded' })
        history.replace(parentId ? '/library/folder/' + parentId : '/library')

        setTimeout(() => {
          dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
        }, 1000)

        return Promise.resolve(response.data)
      } else {
        throw new Error(response.data.message || 'Upload failed')
      }
    } catch (error) {
      console.error('Multiple upload error:', error)
      dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
      return Promise.reject(error)
    } finally {
      dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent: 0 })
    }
  }
}

export const upload = (event, fileLanguages = null) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const {
      fileUploadStatus,
      parentId,
      selectedOrgGroups,
      selectedUsers,
      selectedLocationGroups,
      selectedRoleGroups,
      selectedStores,
      selectedRoles,
      scope,
      selectedFolder,
    } = getState().library

    if (fileUploadStatus === 'started') {
      return
    }

    const targetFolder = resolveTargetFolder(selectedFolder, parentId)

    const nodes = event.target.elements

    const nameInput = [].filter.call(nodes, (item) => item.type === 'text')[0]
    const pathInput = [].filter.call(nodes, (item) => item.type === 'text')[1]

    const newTabCheckbox = nodes['new_tab']

    const name = nameInput.value
    const path = pathInput.value

    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]
    const thumbInput = [].filter.call(nodes, (item) => item.type === 'file')[1]

    const newTab = newTabCheckbox?.checked
    let thumb
    let file
    if (path) {
      thumb = fileInput?.files[0]
    } else {
      file = fileInput.files[0]
      thumb = thumbInput?.files[0]
    }

    const data = new FormData()

    if (!fileLanguages || fileLanguages?.length === 2) {
    } else if (fileLanguages?.length === 1) {
      if (fileLanguages[0].option) {
        data.append('language', fileLanguages[0].option.value)
      } else {
        data.append('language', fileLanguages[0].value)
      }
    }

    if (path) {
      if (!isValidURL(path)) {
        alert('Please enter a valid URL')
        return
      }
      data.append('path', path)
    }

    if (newTabCheckbox) {
      data.append('new_tab', newTab)
    } else {
      data.append('new_tab', true)
    }

    data.append('file', file)

    if (thumb) {
      data.append('thumbnail', thumb)
    }
    data.append('name', name)
    if (targetFolder) {
      data.append('parent_id', targetFolder)
    }

    data.append('selectedFolder', targetFolder || 'lib')

    data.append('type', 'file')

    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null

    if (!file && !path) {
      alert(language.alerts ? language.alerts.select_file : null)
      return
    }

    if (isTextEmpty(name)) {
      alert('Title cannot be empty')
      return
    }

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    const selectedGroups = [
      ...selectedOrgGroups,
      ...selectedLocationGroups,
      ...selectedRoleGroups,
    ]

    selectedGroups.map((item, index) => {
      data.append('groups[' + index + ']', item)
    })

    selectedUsers.map((item, index) => {
      data.append('users[' + index + ']', item)
    })

    selectedRoles.map((item, index) => {
      data.append('roles[' + index + ']', item)
    })

    selectedStores.map((item, index) => {
      data.append('stores[' + index + ']', item)
    })

    data.append('scope', scope)

    axios
      .post(`${clientBaseUrl()}/library?token=${accessToken()}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )

          dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent })
        },
      })
      .then(({ data: saved }) => {
        // The API answers failures with a 200 and just a message.
        if (!saved || !saved.id) {
          throw new Error((saved && saved.message) || 'Something went wrong')
        }

        // Show the new item right away instead of refetching the whole library.
        dispatch(upsertLibraryItems([saved]))

        dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'uploaded' })
        history.replace(parentId ? '/library/folder/' + parentId : '/library')
        setTimeout(() => {
          dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
        }, 1000)
        dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent: 0 })

        return Promise.resolve(saved)
      })
      .catch((error) => {
        dispatch(resetUploadState())
        return Promise.reject(error)
      })
  }
}

export const addFolder = (event, addToDrive = false, driveFolderId = null) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const {
      selectedOrgGroups,
      selectedUsers,
      selectedLocationGroups,
      selectedStores,
      selectedRoles,
    } = getState().library

    const { user } = getState().auth

    let { scope, parentId } = getState().library

    const nodes = event.target.elements
    const nameInput = [].filter.call(nodes, (item) => item.type === 'text')[0]
    const thumbInput = nodes['thumbnail']

    const name = nameInput.value
    const thumb = thumbInput?.files[0]

    const data = new FormData()

    if (addToDrive) {
      data.append('created_by', user.id)
      if (driveFolderId) {
        parentId = driveFolderId
      }
    }

    if (thumb) {
      data.append('thumbnail', thumb)
    }

    data.append('name', name)
    parentId ? data.append('parent_id', parentId) : null //eslint-disable-line

    data.append('type', 'folder')

    if (isTextEmpty(name)) {
      alert('Please type the name of the folder')
      return
    }

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    const selectedGroups = [...selectedOrgGroups, ...selectedLocationGroups]

    selectedGroups.forEach((item, index) => {
      data.append('groups[' + index + ']', item)
    })

    selectedUsers.forEach((item, index) => {
      data.append('users[' + index + ']', item)
    })

    selectedRoles.forEach((item, index) => {
      data.append('roles[' + index + ']', item)
    })

    selectedStores.forEach((item, index) => {
      data.append('stores[' + index + ']', item)
    })

    data.append('scope', scope)

    axios
      .post(`${clientBaseUrl()}/library?token=${accessToken()}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )

          dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent })
        },
      })
      .then(({ data: saved }) => {
        // The API answers failures with a 200 and just a message.
        if (!saved || !saved.id) {
          throw new Error((saved && saved.message) || 'Something went wrong')
        }

        dispatch(fetchAllFolders())

        // Drive folders live in "my documents"; library folders show up in place.
        if (addToDrive) {
          dispatch(fetchMyDocuments())
        } else {
          dispatch(upsertLibraryItems([saved]))
        }

        dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'uploaded' })
        history.replace(parentId ? '/library/folder/' + parentId : '/library')
        setTimeout(() => {
          dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
        }, 1000)
        dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent: 0 })
      })
      .catch((error) => {
        dispatch(resetUploadState())
        alert(error.message || 'Something went wrong')
      })
  }
}

export const setFolderTitle = (event) => {
  return (dispatch) => {
    const title = event.target.value
    dispatch({ type: types.SET_FOLDER_TITLE, title })
  }
}

export const selectFolder = (id) => {
  console.log(id, 'selectedfolder id')
  return (dispatch) => {
    dispatch({ type: types.SELECT_FOLDER, id })
  }
}

export const toggleOrgGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedOrgGroups } = getState().library

    const index = selectedOrgGroups.indexOf(id)

    let orgGroups = []

    if (index !== -1) {
      orgGroups = [
        ...selectedOrgGroups.slice(0, index),
        ...selectedOrgGroups.slice(index + 1),
      ]
    } else {
      orgGroups = [...selectedOrgGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups })
  }
}

export const toggleUsers = (id) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().library

    const index = selectedUsers.indexOf(id)

    let users = []

    if (index !== -1) {
      users = [
        ...selectedUsers.slice(0, index),
        ...selectedUsers.slice(index + 1),
      ]
    } else {
      users = [...selectedUsers, id]
    }

    dispatch({ type: types.SET_SELECTED_USERS, users })
  }
}

export const toggleLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedLocationGroups } = getState().library

    const index = selectedLocationGroups.indexOf(id)

    let locationGroups = []

    if (index !== -1) {
      locationGroups = [
        ...selectedLocationGroups.slice(0, index),
        ...selectedLocationGroups.slice(index + 1),
      ]
    } else {
      locationGroups = [...selectedLocationGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_LOCATION_GROUPS, locationGroups })
  }
}

export const toggleRoleGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedRoleGroups } = getState().library

    const index = selectedRoleGroups.indexOf(id)

    let roleGroups = []

    if (index !== -1) {
      roleGroups = [
        ...selectedRoleGroups.slice(0, index),
        ...selectedRoleGroups.slice(index + 1),
      ]
    } else {
      roleGroups = [...selectedRoleGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_ROLE_GROUPS, roleGroups })
  }
}

export const toggleLocations = (id) => {
  return (dispatch, getState) => {
    const { selectedLocations } = getState().library

    const index = selectedLocations.indexOf(id)

    let locations = []

    if (index !== -1) {
      locations = [
        ...selectedLocations.slice(0, index),
        ...selectedLocations.slice(index + 1),
      ]
    } else {
      locations = [...selectedLocations, id]
    }

    dispatch({ type: types.SET_SELECTED_LOCATIONS, locations })
  }
}

export const toggleStores = (id) => {
  return (dispatch, getState) => {
    const { selectedStores } = getState().library

    const index = selectedStores.indexOf(id)

    let stores = []

    if (index !== -1) {
      stores = [
        ...selectedStores.slice(0, index),
        ...selectedStores.slice(index + 1),
      ]
    } else {
      stores = [...selectedStores, id]
    }

    dispatch({ type: types.SET_SELECTED_STORES, stores })
  }
}

export const fetchAllFolders = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/library/folders`).then((folders) => {
      dispatch({ type: types.FETCH_ALL_FOLDERS, folders })

      console.log(folders, 'foldersss')

      const calcDepth = (obj, parent_id, list) => {
        const item = list.find((item) => item.id === parent_id)

        if (item && item.parent_id !== null) {
          obj.directory = obj.directory + 1

          if (item.children.length > 0) {
            calcDepth(obj, item.parent_id, list)
          }
        }

        return obj
      }

      function createTree(list) {
        var map = {},
          node,
          roots = [],
          i

        for (i = 0; i < list.length; i += 1) {
          map[list[i].id] = i // initialize the map

          list[i].children = [] // initialize the children
        }

        for (i = 0; i < list.length; i += 1) {
          node = list[i]

          if (node.parent_id) {
            const objDir = {
              directory: 2,
            }
            const directory = calcDepth(objDir, node.parent_id, list)
            node.directory = directory.directory
            list[map[node.parent_id]].children.push(node)
          } else {
            roots.push(node)
          }
        }
        return roots
      }

      const nestedTree = createTree(folders)

      console.log(nestedTree, 'nestedTree')

      dispatch({ type: types.FETCH_ALL_FOLDERS_NESTED, folders: nestedTree })
    })
  }
}
export const toggleRoles = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().library

    const index = selectedRoles.indexOf(id)

    let roles = []

    if (index !== -1) {
      roles = [
        ...selectedRoles.slice(0, index),
        ...selectedRoles.slice(index + 1),
      ]
    } else {
      roles = [...selectedRoles, id]
    }

    dispatch({ type: types.SET_SELECTED_ROLES, roles })
  }
}

export const fetchAssignedItems = (id) => {
  return (dispatch, getState) => {
    const { groups } = getState().groups
    const orgGroups = []
    const locationGroups = []
    const roleGroups = []
    const locations = []
    const stores = []
    const users = []
    const roles = []
    AxiosInstance.get(`/library/file/${id}/assignees/all`).then((data) => {
      if (data && data.length) {
        data.forEach((item) => {
          switch (item.assignee) {
            case 'group':
              const currentGroup = groups.find(
                (groupItem) => groupItem.id === parseInt(item.assignee_id),
              )

              if (currentGroup && currentGroup.type === 'org') {
                orgGroups.push(parseInt(item.assignee_id))
              } else if (currentGroup && currentGroup.type === 'location') {
                locationGroups.push(parseInt(item.assignee_id))
              } else if (currentGroup && currentGroup.type === 'role') {
                roleGroups.push(parseInt(item.assignee_id))
              }
              break
            case 'store':
              stores.push(parseInt(item.assignee_id))
              break
            case 'role':
              roles.push(parseInt(item.assignee_id))
              break
            case 'user':
              users.push(item.assignee_id)
              break
            default:
              // Handle unknown assignee types
              break
          }
        })

        dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups })
        dispatch({ type: types.SET_SELECTED_LOCATION_GROUPS, locationGroups })
        dispatch({ type: types.SET_SELECTED_ROLE_GROUPS, roleGroups })
        dispatch({ type: types.SET_SELECTED_LOCATIONS, locations })
        dispatch({ type: types.SET_SELECTED_STORES, stores })
        dispatch({ type: types.SET_SELECTED_USERS, users })
        dispatch({ type: types.SET_SELECTED_ROLES, roles })
      }
    })
  }
}

export const onClickSearch = () => {
  return (dispatch, getState) => {
    const value = getState().library.searchValue
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: null })
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value })
  }
}

export const onSearchReset = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: '' })
    dispatch({ type: types.SET_SEARCH_VALUE, value: '' })
  }
}

export const setHomeworkTitle = (event) => {
  return (dispatch) => {
    const title = event.target.value
    dispatch({ type: types.SET_HOMEWORK_TITLE, title })
  }
}

export const uploadHomework = (event, driveFolderId = null) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const userId = getState().auth.user.id

    const nodes = event.target.elements
    const nameInput = [].filter.call(nodes, (item) => item.type === 'text')[0]
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]
    const thumbInput = [].filter.call(nodes, (item) => item.type === 'file')[1]

    const name = nameInput.value
    const file = fileInput.files[0]
    const thumb = thumbInput.files[0]

    const data = new FormData()

    if (file) {
      data.append('file', file)
    }

    if (driveFolderId) {
      data.append('parent_id', driveFolderId)
    }

    if (thumb) {
      data.append('thumbnail', thumb)
    }

    data.append('name', name)

    data.append('created_by', userId)

    if (!name) {
      alert('Please type the title of the homework')
      return
    }

    if (!file) {
      alert('Please upload your homework')
      return
    }

    // data.append('scope', scope)

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    axios
      .post(`${clientBaseUrl()}/library?token=${accessToken()}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )

          dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent })
        },
      })
      .then(({ data }) => {
        dispatch(fetchMyDocuments())
        dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'uploaded' })
        setTimeout(() => {
          dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
        }, 1000)
        dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent: 0 })
      })
      .catch(() => {
        dispatch(resetUploadState())
      })
  }
}

export const filterFiles = (groupId, selectedFilter) => {
  console.log(groupId, 'leart1304')
  return (dispatch, getState) => {
    const locationsFilter = selectedFilter === 'Locations'
    AxiosInstance.get(
      `/library/filter/files/${groupId}?locations=${locationsFilter}`,
    ).then((data) => {
      dispatch({ type: types.SET_FILTERED_FILES_IDS, payload: data })
    })
  }
}

// Multi-select filter: selections = [{ filter: 'Brands' | 'Locations', id }]
// Fetches every selection in parallel and stores the union of file ids
// (a file matches if it is assigned to ANY selected brand / location).
let filterRequestId = 0
export const filterFilesMulti = (selections = []) => {
  return async (dispatch) => {
    const requestId = ++filterRequestId
    if (!selections.length) {
      dispatch({ type: types.SET_FILTERED_FILES_IDS, payload: [] })
      return
    }
    const results = await Promise.all(
      selections.map(({ filter, id }) =>
        AxiosInstance.get(
          `/library/filter/files/${id}?locations=${filter === 'Locations'}`,
        ).catch(() => []),
      ),
    )
    // a newer selection was made while these were loading — drop the stale result
    if (requestId !== filterRequestId) return

    const ids = new Set()
    results.forEach((rows) => {
      if (Array.isArray(rows)) rows.forEach((r) => ids.add(Number(r.file_id)))
    })
    dispatch({
      type: types.SET_FILTERED_FILES_IDS,
      payload: [...ids].map((file_id) => ({ file_id })),
    })
  }
}

export const fetchMyDocuments = () => {
  return (dispatch) => {
    AxiosInstance.get(`/library/self`).then((data) => {
      dispatch({ type: types.SET_MY_DOCUMENTS, data })
    })
  }
}

export const deleteMyDocument = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language //eslint-disable-line
      ? (language = getState().language.language.data)
      : null
    //eslint-disable-next-line
    if (confirm(language.alerts ? language.alerts.delete_file_confirm : null)) {
      AxiosInstance.delete(`/library/${id}`).then((data) => {
        dispatch(fetchMyDocuments())
      })
    }
  }
}

export const setItemIndex = (index) => {
  return (dispatch) => {
    dispatch({ type: types.SET_ITEM_INDEX, index })
  }
}

export const reorderItems = (nextIndex) => {
  return (dispatch, getState) => {
    const { files, itemIndex } = getState().library

    const reduceItems = [
      ...files.slice(0, itemIndex),
      ...files.slice(itemIndex + 1),
    ]

    const newItems = [
      ...reduceItems.slice(0, nextIndex),
      files[itemIndex],
      ...reduceItems.slice(nextIndex),
    ]

    dispatch(setItemIndex(nextIndex))
    dispatch({ type: types.LIBRARY, data: newItems })
  }
}

export const undo = () => ({ type: types.UNDO })
export const present = () => ({ type: types.PRESENT })

export const toggleLibraryOrder = (mode) => {
  return (dispatch, getState) => {
    const { showLibraryReorder } = getState().library
    if (!showLibraryReorder) {
      dispatch(present())
    } else if (mode !== 'saving') {
      dispatch(undo())
    }

    dispatch(setItemIndex(0))
    dispatch({ type: types.TOGGLE_LIBRARY, payload: !showLibraryReorder })
  }
}

export const saveLibraryOrder = () => {
  return (dispatch, getState) => {
    dispatch(present())
    dispatch(toggleLibraryOrder('saving'))

    const { files, parentId } = getState().library

    AxiosInstance.post('/library/reorder', {
      files: files.map((file) => file.id),
      parentId: parentId,
    })
  }
}

export const selectRole = (role) => {
  return (dispatch) => {
    dispatch({ type: types.SET_ROLE_SELECTED, payload: role })
  }
}

export const fetchLibraryFolderRoles = () => {
  return (dispatch) => {
    AxiosInstance.get('/module-assignees/files-roles').then((data) => {
      console.log(data, 'dataLib')
      dispatch({ type: types.SET_LIBRARY_FOLDER_ROLES, payload: data })
    })
  }
}

// Upload note action
export const uploadNote = (
  title,
  content,
  thumbnail = null,
  fileLanguages = null,
) => {
  return (dispatch, getState) => {
    const {
      fileUploadStatus,
      parentId,
      selectedOrgGroups,
      selectedUsers,
      selectedLocationGroups,
      selectedRoleGroups,
      selectedStores,
      selectedRoles,
      scope,
      selectedFolder,
    } = getState().library

    if (fileUploadStatus === 'started') {
      return Promise.reject(new Error('Upload already in progress'))
    }

    const targetFolder = resolveTargetFolder(selectedFolder, parentId)

    const data = new FormData()

    if (!fileLanguages || fileLanguages?.length === 2) {
    } else if (fileLanguages?.length === 1) {
      if (fileLanguages[0].option) {
        data.append('language', fileLanguages[0].option.value)
      } else {
        data.append('language', fileLanguages[0].value)
      }
    }

    // Add note-specific data
    data.append('name', title)
    data.append('text', content) // Changed from 'note_content' to 'text'
    data.append('is_note', '1')
    data.append('type', 'file')
    data.append('scope', scope)
    // data.append('new_tab', 'true')

    // Add thumbnail if provided
    if (thumbnail) {
      data.append('thumbnail', thumbnail)
    }

    // Handle parent folder
    if (targetFolder) {
      data.append('parent_id', targetFolder)
    }
    data.append('selectedFolder', targetFolder || 'lib')

    // Add assignment data if private
    if (scope === 'private') {
      const selectedGroups = [
        ...selectedOrgGroups,
        ...selectedLocationGroups,
        ...selectedRoleGroups,
      ]

      selectedGroups.forEach((item, index) => {
        data.append('groups[' + index + ']', item)
      })

      selectedUsers.forEach((item, index) => {
        data.append('users[' + index + ']', item)
      })

      selectedRoles.forEach((item, index) => {
        data.append('roles[' + index + ']', item)
      })

      selectedStores.forEach((item, index) => {
        data.append('stores[' + index + ']', item)
      })
    }

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    return axios
      .post(`${clientBaseUrl()}/library?token=${accessToken()}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )
          dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent })
        },
      })
      .then(({ data: saved }) => {
        // The API answers failures with a 200 and just a message.
        if (!saved || !saved.id) {
          throw new Error((saved && saved.message) || 'Something went wrong')
        }

        // Show the new note right away instead of refetching the whole library.
        dispatch(upsertLibraryItems([saved]))

        dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'uploaded' })
        history.replace(parentId ? '/library/folder/' + parentId : '/library')
        setTimeout(() => {
          dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
        }, 1000)
        dispatch({ type: types.LIBRARY_UPLOAD_PERCENT, percent: 0 })

        return Promise.resolve(saved)
      })
      .catch((error) => {
        dispatch(resetUploadState())
        return Promise.reject(error)
      })
  }
}
